// Base URL of the gallery API (photos, thumbnails, clusters, similar-image search).
//
// This used to be a DigitalOcean droplet at backendserver.org; it now runs on the
// Mac (app.py) and is reached through the Cloudflare Tunnel.
// Override for local dev with REACT_APP_API_BASE=http://localhost:8400
export const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.fabianmorelli.de';

export default API_BASE;
